import { useEffect, useState } from "react";
import {
  analyticsAvailable,
  analyticsChoice,
  enableAnalytics,
  recordCurrentPageView,
  setAnalyticsChoice,
} from "./analytics";
import "./AnalyticsConsent.css";

function isAcquisitionPage(path: string): boolean {
  return path === "/" || path === "/react/signup" || path === "/react/signup/"
    || path === "/instagram-crm/" || path === "/instagram-crm-india/" || path === "/instagram-comment-auto-reply/" || path === "/facebook-lead-crm/" || path === "/whatsapp-crm/"
    || path === "/social-commerce/" || path.startsWith("/blog/");
}

export function AnalyticsConsent({ pathname }: { pathname: string }) {
  const enabled = analyticsAvailable() && isAcquisitionPage(pathname);
  const [choice, setChoice] = useState(() => analyticsChoice());
  const [settingsOpen, setSettingsOpen] = useState(choice === null);

  useEffect(() => {
    if (enabled && choice === "accepted") {
      enableAnalytics();
      recordCurrentPageView();
    }
  }, [choice, enabled, pathname]);

  if (!enabled) return null;

  const choose = (nextChoice: "accepted" | "declined") => {
    setAnalyticsChoice(nextChoice);
    setChoice(nextChoice);
    setSettingsOpen(false);
  };

  return settingsOpen ? (
    <aside className="lc-analytics-consent" aria-label="Optional website analytics">
      <div>
        <strong>Help us improve LeadCat</strong>
        <p>May we use Google Analytics to understand which public pages lead to workspace signups? It starts only if you accept. We do not send names, contact details or lead messages. <a href="/privacy.html">Privacy details</a></p>
      </div>
      <div className="lc-analytics-actions">
        <button type="button" onClick={() => choose("declined")}>Decline</button>
        <button type="button" className="lc-analytics-accept" onClick={() => choose("accepted")}>Accept analytics</button>
      </div>
    </aside>
  ) : (
    <button className="lc-analytics-reopen" type="button" onClick={() => setSettingsOpen(true)}>
      Analytics settings
    </button>
  );
}
